document.addEventListener("DOMContentLoaded", function () {
	var mainEl = document.querySelector('main[data-template="index"]');
	if (!mainEl) return;

	var revealEls = document.querySelectorAll(".code369-reveal, .code369-reveal-left, .code369-reveal-right");
	if ("IntersectionObserver" in window) {
		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				entry.target.classList.toggle("is-visible", entry.isIntersecting);
			});
		}, { threshold: [0, 0.15], rootMargin: "0px 0px -8% 0px" });
		revealEls.forEach(function (el) { observer.observe(el); });
	} else {
		revealEls.forEach(function (el) { el.classList.add("is-visible"); });
	}

	var starfield = document.createElement("div");
	starfield.className = "code369-starfield";
	for (var i = 0; i < 45; i++) {
		var star = document.createElement("span");
		star.className = "code369-star";
		star.style.left = (Math.random() * 100) + "vw";
		star.style.top = (Math.random() * 100) + "vh";
		star.style.animationDelay = (Math.random() * 3.5) + "s";
		star.style.opacity = (0.3 + Math.random() * 0.7).toFixed(2);
		starfield.appendChild(star);
	}
	document.body.appendChild(starfield);

	var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	if (!prefersReducedMotion && "animate" in document.createElement("span")) {
		var shootingStarTimeoutId = null;

		function scheduleShootingStar() {
			var wait = 700 + Math.random() * 1400;
			shootingStarTimeoutId = setTimeout(function () {
				spawnShootingStar(starfield);
				scheduleShootingStar();
			}, wait);
		}

		if (!document.hidden) {
			scheduleShootingStar();
		}

		document.addEventListener("visibilitychange", function () {
			clearTimeout(shootingStarTimeoutId);
			if (!document.hidden) {
				scheduleShootingStar();
			}
		});
	}

	function spawnShootingStar(field) {
		var star = document.createElement("span");
		star.className = "code369-shooting-star";

		var startX = Math.random() * 100;
		var startY = Math.random() * 80;
		var dx = Math.random() * 70 - 35;
		var dy = 25 + Math.random() * 130;
		var angle = Math.atan2(dy, dx) * (180 / Math.PI);
		var distance = Math.sqrt(dx * dx + dy * dy);
		var length = 80 + Math.random() * 100;
		var duration = 550 + distance * 9 + Math.random() * 300;

		star.style.left = startX + "vw";
		star.style.top = startY + "vh";
		star.style.width = length + "px";
		field.appendChild(star);

		var anim = star.animate([
			{ transform: "translate(0, 0) rotate(" + angle + "deg)", opacity: 0 },
			{ transform: "translate(" + (dx * 0.15) + "vw, " + (dy * 0.15) + "vh) rotate(" + angle + "deg)", opacity: 1, offset: 0.15 },
			{ transform: "translate(" + dx + "vw, " + dy + "vh) rotate(" + angle + "deg)", opacity: 0 }
		], { duration: duration, easing: "linear" });

		anim.onfinish = function () { star.remove(); };
	}

	var heroContent = document.querySelector(".code369-hero-content");
	if (heroContent) {
		heroContent.addEventListener("mousemove", function (e) {
			var rect = heroContent.getBoundingClientRect();
			var x = ((e.clientX - rect.left) / rect.width) * 100;
			var y = ((e.clientY - rect.top) / rect.height) * 100;
			heroContent.style.setProperty("--spot-x", x + "%");
			heroContent.style.setProperty("--spot-y", y + "%");
		});
	}
});
